/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import type { EntityLimitType as ProjectEntityLimitType } from '@jira/polaris__domain-project/src/ProjectMetadata.types.tsx';
import type { EntityLimitType as CollectionEntityLimitType } from '@jira/polaris__domain-collection/src/EntityLimitType.types.tsx';
import { useHasReachedViewsLimit } from '@jira/polaris__component-navigation-store/src/useIsNavigationLocked.tsx';
import { useEntityLimitMessage } from '@jira/polaris__component-limits/src/useEntityLimitMessage.tsx';
import { CreateEntityLimitTooltip } from '@jira/polaris__component-limits/src/CreateEntityLimitTooltip.tsx';

type ActionItemTooltipProps = {
	children: React.ReactNode;
	entityLimitMessage?: React.ReactNode;
};

const ActionItemTooltip = ({ children, entityLimitMessage }: ActionItemTooltipProps) => {
	if (entityLimitMessage) {
		return (
			<CreateEntityLimitTooltip message={entityLimitMessage}>{children}</CreateEntityLimitTooltip>
		);
	}

	return <>{children}</>;
};

export const HardLimitsTooltip = ({
	containerId,
	entityLimitType,
	children,
}: {
	containerId: string;
	entityLimitType: ProjectEntityLimitType | CollectionEntityLimitType;
	children: ({ isLimitReached }: { isLimitReached: boolean }) => React.ReactNode;
}): React.JSX.Element => {
	const limitValue = useHasReachedViewsLimit({
		containerId,
		entityLimitType,
	});

	const getEntityLimitMessage = useEntityLimitMessage();
	const isLimitReached = limitValue !== null;

	return (
		<ActionItemTooltip
			entityLimitMessage={limitValue && getEntityLimitMessage(entityLimitType, limitValue)}
		>
			{children({ isLimitReached })}
		</ActionItemTooltip>
	);
};
